import axios from 'axios';
import { CaseMessage, CaseDetails, CaseDocuments } from '../../types';
import { baseApiClient } from '../clients';

const CASE_DETAILS_URL = '/cases/';
const CASE_DETAILS_MESSAGES_URL = '/notes';
const CASE_DETAILS_DOCUMENTS_URL = '/documents';
const CASE_DETAILS_DOCUMENT_URL = '/documents/';

export const getMessages = (caseId: string) => {
  return baseApiClient.get<{ notes: CaseMessage[] }>(
    `${CASE_DETAILS_URL}${caseId}${CASE_DETAILS_MESSAGES_URL}`,
  );
};
export const postMessages = (caseId: string, message: string, documents: string[]) => {
  return baseApiClient.post(`${CASE_DETAILS_URL}${caseId}${CASE_DETAILS_MESSAGES_URL}`, {
    noteText: message,
    fileUploadIds: documents,
  });
};

export const getDetails = (caseId: string) => {
  return baseApiClient.get<CaseDetails>(`${CASE_DETAILS_URL}${caseId}`);
};

export const getCaseDocuments = (caseId: string) => {
  return baseApiClient.get<CaseDocuments>(
    `${CASE_DETAILS_URL}${caseId}${CASE_DETAILS_DOCUMENTS_URL}`,
  );
};

export const getCaseDocument = (caseId: number, documentId: number, fileName: string) => {
  const token = localStorage.getItem('access_token');
  const BASE_URL = runtimeConfig.apiUrl;

  return axios({
    baseURL: BASE_URL,
    headers: {
      Authorization: `Bearer ${token}` || '',
    },
    url: `${CASE_DETAILS_URL}${caseId}${CASE_DETAILS_DOCUMENT_URL}${documentId}`,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });
};
